/**
 * Routes whose page component renders its own edge-to-edge sticky app-bar (back button + title)
 * and manages all of its own spacing — these need the shell's `<main>` to have zero page padding
 * (a true full-bleed canvas), not just hidden chrome. Every other secondary route still gets
 * `.page-wrap-mobile` padding around its own (non-sticky) in-page back button/content.
 */
export function usesFullBleedMobileCanvas(pathname: string): boolean {
  return /^\/roles\/(?:new|[^/]+)\/?$/.test(pathname) || /^\/visits\/[^/]+\/?$/.test(pathname);
}
